import React from 'react';

const CityTabs = ({ cities, activeId, onSelect }) => (
  <div
    role="tablist"
    aria-label="Departure city"
    style={{
      display: 'flex',
      gap: 10,
      overflowX: 'auto',
      paddingBottom: 4,
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {cities.map(city => {
      const active = city.id === activeId;
      return (
        <button
          key={city.id}
          role="tab"
          aria-selected={active}
          aria-controls={`htr-panel-${city.city_slug}`}
          id={`htr-tab-${city.city_slug}`}
          onClick={() => onSelect(city.id)}
          style={{
            padding: '9px 22px',
            borderRadius: 30,
            border: active ? '2px solid #16a34a' : '2px solid #e5e7eb',
            backgroundColor: active ? '#16a34a' : 'white',
            color: active ? 'white' : '#374151',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.2s',
            fontFamily: "inherit",
          }}
        >
          {city.city_name}
        </button>
      );
    })}
  </div>
);

export default CityTabs;
